var React = require('react');

function ChevronLeft (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;}")),React.createElement("path",{"className":"cls-1","d":"M18.4.5,5.825,11.626a.5.5,0,0,0,0,.748L18.4,23.5","key":1})]);
}

ChevronLeft.defaultProps = {"id":"Light","viewBox":"0 0 24 24"};

module.exports = ChevronLeft;

ChevronLeft.default = ChevronLeft;



//////////////////
// WEBPACK FOOTER
// ./src/components/icon/svgs/chevron-left.svg
// module id = 1063
// module chunks = 0